// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"c2271ece","197":"fb0650e3","244":"50afec61","261":"2b063476","352":"c2271ece","372":"2b063476","528":"2b063476","690":"b305e338","697":"a67acdea","714":"a67acdea","737":"c2271ece","929":"8999511a"}[chunkId] + ".chunk.css";
};